import { SerializableObject } from '../../common-react/core';

import { FamilyMember } from './family-member.do';

export class Family extends SerializableObject {
  public familyMembers: FamilyMember[];
  public canChangeAddress: boolean;
}
